<template>
  <div class="checkListPage">
    <ul class="ulBox clearFloat">
      <li class="blockLi">
        <div class="right">
          <el-table
            class="myProductionOrder"
            stripe
            :data="SNData"
            border
            style="width: 100%"
            size="mini"
          >
          <el-table-column
            type="index" align="center"
            width="60">
          </el-table-column>
            <el-table-column  label="SN"
              prop="sn" min-width="100" align="center" show-overflow-tooltip>
              <template slot-scope="scope">                
                <span :class="scope.row.resultCode ? (scope.row.resultCode.code!=0 ? 'fail' : 'pass') : ''">
                {{scope.row.sn ? scope.row.sn : '-'}}
                </span>
              </template>
            </el-table-column>
            <el-table-column  label="UUID"
              prop="sn" min-width="100" align="center" show-overflow-tooltip>
              <template slot-scope="scope">                
                <span :class="scope.row.resultCode ? (scope.row.resultCode.code!=0 ? 'fail' : 'pass') : ''">
                {{scope.row.uuid ? scope.row.uuid : '-'}}
                </span>
              </template>
            </el-table-column>
            <el-table-column  label="MAC"
              prop="sn" min-width="100" align="center" show-overflow-tooltip>
              <template slot-scope="scope">                
                <span :class="scope.row.resultCode ? (scope.row.resultCode.code!=0 ? 'fail' : 'pass') : ''">
                {{scope.row.mac ? scope.row.mac : '-'}}
                </span>
              </template>
            </el-table-column>
            <el-table-column  label="被抽检"
              prop="check" min-width="100" align="center" show-overflow-tooltip>
              <template slot-scope="scope">                
                <i v-if="scope.row.check" :class="scope.row.resultCode ? (scope.row.resultCode.code!=0 ? 'el-icon-check fail' : 'el-icon-check pass') : 'el-icon-check'"></i>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column  label="二次送检"
              prop="reCheck" min-width="100" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <i v-if="scope.row.reCheck" :class="scope.row.resultCode ? (scope.row.resultCode.code!=0 ? 'el-icon-check fail' : 'el-icon-check pass') : 'el-icon-check'"></i>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="抽检结果"
              prop="result" min-width="100" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <span :class="scope.row.resultCode ? (scope.row.resultCode.code!=0 ? 'fail' : 'pass') : ''">
                  <i v-if="scope.row.resultCode && scope.row.resultCode.code==0" class="el-icon-check"></i>
                  <i v-else-if="scope.row.resultCode" class="el-icon-close"></i>{{ scope.row.resultCode ? scope.row.resultCode.name : '-' }}
                </span>
              </template>
            </el-table-column>            
          </el-table>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import {
  apiQcCheckListDetailSN,
} from "@/api/qcOrder.js";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
  },
  computed: {
  },
  components: {
    
  },
  data() {
    return {
      DetailData: {},
      SNData:[],
      pullDownData: {
        productOrderList: [],
      },
      dialogVisible: false,
      dialogTitle: "",
      dialogForm: {
      },
      dialogRules: {
        minBuild: [
          { required: true, message: "版本号不能为空！", trigger: "blur" },
        ],
      },
      labelWidth: this.$store.state.labelWidth,
      fileText: "未选择任何文件",
    };
  },
  methods: {
    async detailSn(searchConditionForm, callback) {
      const res = await apiQcCheckListDetailSN({
        id: this.tabPaneValue,
        sn: searchConditionForm.sn,
        uuid: searchConditionForm.uuid,
        mac: searchConditionForm.mac
      });
      if (res.code == 0) {
        this.SNData = res.data;
        if (callback) callback();
      }
    }
  }
};
</script>

<style lang="less" scoped>
  .pass {
    color: #67C23A;
  }
  .fail {
    color: #f56c6c;
  }
</style>
